<template>
  <div class="ui-work-type-tag" :style="{ background: bgColor }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "workTypeTag",
  props: {
    bgColor: {
      type: String,
      default: "transparent"
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-work-type-tag {
  position: absolute;
  bottom: 0;
  right: -0.01rem;
  height: 20px;
  padding: 4px 6px;
  border-top-left-radius: 0.16rem;
  font-family: PingFangSC-Regular;
  font-size: 0.22rem;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 0.24rem;
  max-width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-sizing: border-box;
}
</style>
